export default __webpack_public_path__ + "static/media/blog-img108.156c526e.jpg";